/**
 * Expand a path template by substituting `:tokenName` segments with values
 * from the provided map. Returns null when any token is missing so callers
 * can defer rendering rather than navigate to a broken URL.
 */
export function expandPath(
  template: string,
  tokens: Record<string, string | undefined> = {}
): string | null {
  if (!template) return null;

  const queryIndex = template.search(/[?#]/);
  const pathPart = queryIndex === -1 ? template : template.slice(0, queryIndex);
  const rest = queryIndex === -1 ? '' : template.slice(queryIndex);

  const expanded: string[] = [];
  for (const segment of pathPart.split('/')) {
    if (segment.startsWith(':')) {
      const value = tokens[segment.slice(1)];
      if (!value) return null;
      expanded.push(encodeURIComponent(value));
    } else {
      expanded.push(segment);
    }
  }

  return expanded.join('/') + rest;
}
